export enum UserRoles {
  superAdmin = "super-admin",
  owner = "owner",
  admin = "admin",
  user = "user"
}

export enum ScreenArtboardScrollDirection {
  vertical = "vertical",
  horizontal = "horizontal",
  noscroll = "noscroll"
}

export enum EventRecurrences {
  weekly = "weekly",
  monthly = "monthly",
  yearly = "yearly"
}

export enum EventSubTypes {
  event = 'event',
  quickEvent = 'quickEvent'
}

export enum TICKET_STATUSES {
    'open',
    'closed'
}

export enum TICKET_COMMENT_TYPES {
    'ticket-close',
    'ticket-reopen',
    'ticket-comment'
}
export enum ZmanimDisplayOverrideRoundTo {
  high = "round to high",
  closer = "round to closer",
  lower = "round to lower"
}

export enum YurtzeitenStatus_N {
  pending = "pending",
  approved = "approved",
  rejected = "rejected"
}

// Mirrors the backend enum of the same name — the stored values, not the
// labels. `yurtzeiten_relationship.ts` holds the wording each one is shown
// with, and the option list the forms render from.
export enum YurtzeitenRelationship_N {
  parent = "parent",
  grandparent = "grandparent",
  greatGrandparent = "great-grandparent",
  spouse = "spouse",
  sibling = "sibling",
  child = "child",
  grandchild = "grandchild",
  uncle = "uncle",
  aunt = "aunt",
  nephew = "nephew",
  niece = "niece",
  cousin = "cousin",
  inLaw = "in-law",
  otherRelative = "other-relative",
  friend = "friend",
  teacher = "teacher",
  other = "other"
}
